import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { showCompanyListAtom } from "@/features/Navigation/state";
import { useAtom, useSetAtom } from "jotai";
import clsx from "clsx";
import { RightDrawerContent } from "@/features/Navigation/components/RightDrawerContent";
import { ConnectorList } from "@/features/Connectors/components/ConnectorList";
import { motion } from "framer-motion";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import { useEffect } from "react";
import { ConnectorPanel } from "@/features/Connectors/components/ConnectorPanel";

export default function ConnectorsPage() {
    const [showCompanyList] = useAtom(showCompanyListAtom);
    const selectedConnectorId = "1";
    const setRightDrawerOpen = useSetAtom(rightDrawerOpenAtom);

    useEffect(() => {
        setRightDrawerOpen(true);
    }, []);

    return (
        <>
            <div>
                {!showCompanyList && (
                    <SidebarPortal>
                        <ConnectorList />
                    </SidebarPortal>
                )}

                {selectedConnectorId && (
                    <RightDrawerContent onClose={() => {}}>
                        <ConnectorPanel />
                    </RightDrawerContent>
                )}
            </div>
            <motion.div className="flex size-full">
                <div
                    className={clsx("size-full px-6", "flex flex-col", "gap-3")}
                >
                    {/* {!selectedFileId && <LabelingEmptyState />} */}
                    {/* <FileHeading /> */}
                    {/* <FileView /> */}
                </div>
            </motion.div>
        </>
    );
}
